import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Navigate } from "react-router-dom";
import moment from "moment/moment";
import { saveAs } from "file-saver";
import { getDate } from "date-fns";
import DropdownAction from "../../components/dropdown/DropdownAction";
import SearchBar from "../../components/membership/SearchBar";
import DropdownSelect from "../../components/dropdown/Dropdown";
import DatePicker from "../../components/datePicker/DatePicker";
import SwalServices from "../../services/swalServices/SwalServices";
import MembershipCorporateServices from "../../services/axiosServices/apiServices/MembershipCorporateServices";
import Table from "../../components/table/Table";
import ActionContainer from "../../components/UIComponent/ActionTableComponent/actionContainer";
import { CommonSuccessMessages } from "../../utils/Messages";
import { encryptAES } from "../../utils/Encryption";
import CorporateMemberServices from "../../services/axiosServices/apiServices/CorporateMemberServices";
import RepresentativeDetailsModal from "../membership/membershipRenewalDashboard/RepresentativeDetailsModal";
//import CommonServices from "../../../services/axiosServices/apiServices/CommonServices";
import IndividualMemberService from "../../services/axiosServices/apiServices/IndividualMemberService";

export default class ViewPosting extends Component {
  constructor(props) {
    super(props);
    this.membershipCorporateServices = new MembershipCorporateServices();
    this.corporateMemberServices = new CorporateMemberServices();
    this.individualMemberService = new IndividualMemberService();
    this.swalServices = new SwalServices();
    this.state = {
      pagination: {
        pageNo: 1,
        pageSize: 10,
        orderByColumn: "",
        orderFlag: 0,
        collobrationTypeId: 0,
        collobrationStartDate: "",
        collobrationEndDate: "",
        IsAvailablePostings: false,
        IsAdmin: true,
        LoggedInMembeId: 0,
      },
      isLoadingcancelInvoice: false,
      councilIndex: 0,
      setRepresentativeDetailsModal: false,
      receiverOrganisationName: "",
      postingList: [],
      totalMembersFullyRenewed: 0,
      totalMembersPaid: 0,
      totalMembersDeclared: 0,
      renewalYear: 0,
      dataGetting: false,
      represenativesData: [],
      totalResultes: 0,
      totalMembers: 0,

      paymentStatus: [
        { id: 1, name: "Pending" },
        { id: 3, name: "Submitted" },
        { id: 2, name: "Paid" },
      ],
      formStatus: [
        { id: 1, name: "Pending" },
        { id: 3, name: "Submitted" },
        { id: 2, name: "Updated" },
      ],
      membershipTypes: [],
      actionDropdown: ["Activate", "Deactivate", "Update", "Delete"],
      collaborationList: [],
    };
  }

  searchText = (value) => {
    let detail = this.state.pagination;
    detail.pageNo = 1;
    detail.pageSize = 10;
    detail.searchText = value;
    this.setState({ pagination: { ...detail } }, () => {
      this.getAllPostings();
    });
  };

  setPagination = (newPagination) => {
    this.setState({ pagination: newPagination }, () => {
      this.getAllPostings();
    });
  };

  onClose = () => {
    this.setState({ setDropdownOpen: false });
  };

  actionClick = (index, value, option) => {
    if (value && value > 0 && option === "Deactivate") {
      this.deActivateCorporateMemnber(value);
    }
    if (value && value > 0 && option === "Activate") {
      this.activeInActiveCorporateMember(value);
    }
    if (value && value > 0 && option === "Update") {
      this.updateCorporateMemberUpdate(value);
    }
    if (value && value > 0 && option === "Delete") {
      this.deleteCorporateMember(value);
    }
  };

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
      this.setState({ setDropdownOpen: false });
    }
  }
  deActivateCorporateMemnber = (value) => {
    let request = {
      id: value,
      statusId: 7,
    };
    this.setState({ isLoading: true });
    this.membershipCorporateServices
      .activeInActiveCorporateMember(request)
      .then((response) => {
        if (response.statusCode === 200) {
          this.swalServices.Success(
            "Corporate member deactivated Successfully."
          );
          this.getAllRenewalList();
        } else {
          this.swalServices.Error(response.message);
        }
        this.setState({ isLoading: false });
      });
  };

  activeInActiveCorporateMember = (value) => {
    let request = {
      id: value,
      statusId: 8,
    };
    this.setState({ isLoading: true });
    this.membershipCorporateServices
      .activeInActiveCorporateMember(request)
      .then((response) => {
        if (response.statusCode === 200) {
          this.swalServices.Success("Corporate member activated Successfully.");
          this.getAllRenewalList();
        } else {
          this.swalServices.Error(response.message);
        }
        this.setState({ isLoading: false });
      });
  };
  cancelInvoiceAndRegenerateRenewalInvoice = (id, id2) => {
    if (id > 0 && id != null) {
      let request = [id, id2];
      this.setState({ isLoadingcancelInvoice: true });
      this.corporateMemberServices
        .cancelInvoiceAndRegenerateRenewalInvoice(request)
        .then((response) => {
          if (
            response.statusCode === 200 &&
            response.responseItem.responseContent != null
          ) {
            this.swalServices.Success("Invoice regenerated Successfully");

            this.setState({ setRepresentativeDetailsModal: false, isLoadingcancelInvoice: false });
          } else {
            this.swalServices.Warning("Invoice not regenerated");
            this.setState({ setRepresentativeDetailsModal: false, isLoadingcancelInvoice: false });
          }
        });
    }
  };
  updateCorporateMemberUpdate = (value) => {
    if (value && value > 0) {
      this.setState({
        route:
          "/CreateCorporateMembers/CorporateMemberId?=" + encryptAES(value),
      });
    }
  };

  deleteCorporateMember = (value) => {
    let request = {
      id: value,
      deletedBy: 1,
      appId: 115,
    };
    this.swalServices
      .Confirm(
        CommonSuccessMessages.Confirm_Question.replace("{0}", "Member"),
        CommonSuccessMessages.Confirm_Delete.replace("{0}", "Member"),
        CommonSuccessMessages.Yes_Text,
        CommonSuccessMessages.No_Text
      )
      .then((response) => {
        if (response) {
          this.membershipCorporateServices
            .deleteCorporateMember(request)
            .then((response) => {
              if (response.statusCode === 200) {
                this.swalServices.Success("Deleted");
                this.getAllRenewalList();
              } else {
                this.swalServices.Error(response.message);
              }
              this.setState({ isLoading: false });
            });
        }
      });
  };

  actions = (element, index, value) => {
    return element !== "corporateMemberId" ? null : (
      <td>
        <ActionContainer>
          <DropdownAction
            key={index}
            index={index}
            value={value}
            options={this.state.actionDropdown}
            align="right"
            onOptionClick={this.actionClick.bind(this)}
          />
        </ActionContainer>
      </td>
    );
  };

  redirectTomanagePosting = (value) => {
    this.setState({
      route: "/ManagePosting?collaborationPortalPostingId=" + encryptAES(value),
    });
  };

  actions2 = (element, index, value) => {

    return (
      <span
        onClick={() => this.redirectTomanagePosting(value)}
        style={{
          color: "red",
          textDecoration: "underline",
          fontSize: "16px",
          display: "inline-block",
          marginTop: "17px",
          marginLeft: "22px",
          cursor: "pointer",
        }}
      >
        View
      </span>
    );
  };

  showRepresentativesDetails = (e, id, index) => {
    e.stopPropagation();
    this.setState({ councilIndex: index, setRepresentativeDetailsModal: true });
  };

  getAllCorporateStatus = () => {
    this.membershipCorporateServices
      .getAllCorporateStatus()
      .then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          //this.setState({ statuses: response.responseItem.responseContent }, () => this.getAllRenewalList());
          this.getAllRenewalList();
        } else {
          this.getAllRenewalList();
          this.swalServices.Error(response.message);
        }
        this.setState({ isLoading: false });
      });
  };

  getAllDropdownForCorporateMember = () => {
    this.corporateMemberServices
      .getAllDropdownForCorporateMember()
      .then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          var collaborationType = response.responseItem.responseContent.filter(
            (drp) => drp.dropdownName === "CollaborationType"
          );
          collaborationType.map(function (item) {
            delete item["dropdownName"];
            return item;
          });
          this.setState({ collaborationList: collaborationType });
        }
      });
  };

  getAllRenewalList = (pagination = this.state.pagination) => {
    pagination.renewalYear =
      this.state.pagination.renewalYear === 0
        ? new Date().getFullYear()
        : this.state.pagination.renewalYear;
    this.setState({ isLoading: true });
    this.corporateMemberServices
      .getAllRenewalList(pagination)
      .then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          let details = response.responseItem.responseContent.itemList;

          let totalMembersFullyRenewed = 0;
          let totalMembersPaid = 0;
          let totalMembersDeclared = 0;
          let totalMembers = 0;

          let renewalYear = "";

          details.map((key, index) => {
            key.renewalDate =
              key.renewalDate === "Invalid date"
                ? "-"
                : moment(key.renewalDate).format("DD MMM YYYY");
            key.paidDate =
              key.paidDate === "Invalid date" ||
              !moment(key.paidDate, moment.ISO_8601, true).isValid()
                ? "-"
                : moment(key.paidDate).format("DD MMM YYYY");
            if (key.membershipTypeName === "Associate") {
              key.formDate = "NA";
            } else {
              key.formDate =
                key.formDate === "Invalid date" ||
                !moment(key.formDate, moment.ISO_8601, true).isValid()
                  ? "-"
                  : moment(key.formDate).format("DD MMM YYYY");
            }
            if (key.organisationName === null || key.organisationName === "") {
              key.organisationName = "-";
            }
            if (key.organisationUEN === null || key.organisationUEN === "") {
              key.organisationUEN = "-";
            }
            totalMembersFullyRenewed = key.totalMembersFullyRenewed || 0;
            totalMembersPaid = key.totalMembersPaid || 0;
            totalMembersDeclared = key.totalMembersDeclared || 0;
            totalMembers = key.totalMembers || 0;

            renewalYear = key.renewalYear;
            return key;
          });
          this.setState({
            totalMembersFullyRenewed,
            totalMembersPaid,
            totalMembersDeclared,
            renewalYear,
            totalMembers,
          });
          this.setState({ renewalMemberList: details }, () =>
            this.setState({ dataGetting: true })
          );
          this.setState({
            totalResultes: response.responseItem.responseContent.totalCount,
          });
        } else {
          this.swalServices.Error(response.message);
        }
        this.setState({ isLoading: false });
      });
  };

  componentDidMount() {
    // this.getAllCorporateStatus();
    this.getAllDropdownForCorporateMember();
    // document.addEventListener("mousedown", this.handleClickOutside);
    this.getAllPostings();
  }

  getAllPostings = () => {
    this.setState({ isLoading: true }, () => {
      let request = { ...this.state.pagination };
      request.startDate = moment(this.state.pagination.startDate).format(
        "YYYY MMM DD"
      );
      request.endDate = moment(this.state.pagination.endDate).format(
        "YYYY MMM DD"
      );
      request.IsAdmin = true;

      this.individualMemberService.getAllPostings(request).then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          let details = response.responseItem.responseContent.itemList;

          details.map((x) => {
            x.deadlineDate
              ? (x.deadlineDate = moment(x.deadlineDate).format("DD MMM yyyy"))
              : (x.deadlineDate = "-");
            x.postedOn
              ? (x.postedOn = moment(x.postedOn).format("DD MMM yyyy"))
              : (x.postedOn = "-");
            return x;
          });
          const updatedDetails = details.map(item => ({
            ...item,
            isActivePost: item.isActive ? 'Published' : 'Unpublished'
          }));
          
          
          this.setState({
            postingList: updatedDetails,
            totalResultes: response.responseItem.responseContent.totalCount,
          });
          this.setState({ isLoading: false });
        } else {
          this.swalServices.Error("Something went wrong.");
        }
      });
    });
  };

  handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if (name === "collobrationStartDate") {
      let date = this.state.pagination;
      date.collobrationStartDate = value;
      this.setState({ collobrationStartDate: date });
    }
    if (name === "collobrationEndDate") {
      let date = this.state.pagination;
      date.collobrationEndDate = value;
      this.setState({ collobrationEndDate: date });
    }
  };

  // getDateForFileName() {
  //   const date = new Date();
  //   const year = date.getFullYear();
  //   const month = String(date.getMonth() + 1).padStart(2, "0");
  //   const day = String(date.getDate()).padStart(2, "0");
  //   return `${year}${month}${day}`;
  // }

  // downloadExcelForRenewalMembersRecord = () => {
  //   let request = { ...this.state.pagination };
  //   request.pageSize = 100000;
  //   this.corporateMemberServices
  //     .downloadExcelForRenewalMembersRecord(request)
  //     .then((response) => {
  //       if (response.status === 200 && response.data != null) {
  //         let blob = new Blob([response.data]);
  //         if (blob.size > 300) {
  //           saveAs(blob, `RenewalReport_${this.getDateForFileName()}.xlsx`);
  //         } else {
  //           this.swalServices.Error("No Records Found!");
  //         }
  //       } else {
  //         this.swalServices.Error(response.message);
  //       }
  //       this.setState({ isLoading: false });
  //     });
  // };
  setFilterParameters = (id) => {
    let detail = this.state.pagination;
    detail.pageNo = 1;
    detail.collobrationTypeId = id;
    this.setState({ pagination: { ...detail } }, () => {
      this.getAllPostings();
    });
  };

  getPostingDetailsbyId = (id) => {
    if (id > 0) {
      this.individualMemberService
        .getPostingDetailsbyId(id)
        .then((response) => {
          if (response.statusCode === 200 && response.responseItem != null) {
            let res = { ...this.state.postingDetails };
            res.collaborationPortalPostingId =
              response.responseItem.responseContent.collaborationPortalPostingId;
            res.title = response.responseItem.responseContent.title;
            res.description = response.responseItem.responseContent.description;
            res.supportingDocumentPath =
              response.responseItem.responseContent.supportingDocumentPath;
            res.deadlineDate =
              response.responseItem.responseContent.deadlineDate;
            res.name = response.responseItem.responseContent.name;
            res.postedOn = response.responseItem.responseContent.postedOn;
            res.companyName = response.responseItem.responseContent.companyName;
            res.isActive = response.responseItem.responseContent.isActive;
            this.setState({ postingDetails: res });
          } else {
            this.swalServices.Error(response.message);
          }
        });
    }
  };

 

  render() {
    if (this.state.route != null) {
      return <Navigate to={this.state.route} />;
    }
    return (
      <div className="main-body-section">
        <div className="flex">
          <div className="relative flex flex-col flex-1 "></div>
        </div>
        <main className="pb-10">
          <div className="custom-card shadow-lg mb-4 rounded-md p-4">
            <div className="w-full grid gap-4">
              {/* Row 1 - Search by */}
              <div className="w-full">
                <label className="text-[#212529] font-bold mb-2 block">
                  Search by
                </label>
                <input
                  id="default"
                  className="form-input rounded-none w-full shadow-red py-3 text-lg"
                  type="text"
                  placeholder="Title/Description"
                  onChange={(e) => this.searchText(e.target.value)}
                />
              </div>

              {/* Row 2 - Collaboration Type, Dates, and Button */}
              <div className="w-full grid grid-cols-12 gap-4 items-end">
                {/* Collaboration Type */}
                <div className="col-span-12 sm:col-span-4">
                  <label className="text-[#212529] font-bold mb-2 block">
                    Collaboration Type
                  </label>
                  <DropdownSelect
                    drpIdentity="TypeName"
                    optionArray={this.state.collaborationList}
                    setFilterParameters={this.setFilterParameters.bind(this)}
                    value={this.state.pagination.collobrationTypeId}
                  />
                </div>

                {/* Collaboration Date From */}
                {/* Collaboration Date Range */}
                <div className="col-span-12 sm:col-span-6">
                  <label className="text-[#212529] font-bold mb-2 block">
                    Collaboration Dateline
                  </label>
                  <div className="flex items-center gap-2">
                    {/* Start Date */}
                    <div className="w-1/2">
                      <input
                        id="collobrationStartDate"
                        name="collobrationStartDate"
                        className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                        type="date"
                        value={moment(
                          this.state.pagination.collobrationStartDate
                        ).format("yyyy-MM-DD")}
                        onChange={(event) => this.handleChange(event)}
                      />
                    </div>

                    {/* Till label */}
                    <span className="text-[#212529] font-semibold mx-1">
                      till
                    </span>

                    {/* End Date */}
                    <div className="w-1/2">
                      <input
                        id="collobrationEndDate"
                        name="collobrationEndDate"
                        className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                        type="date"
                        value={moment(
                          this.state.pagination.collobrationEndDate
                        ).format("yyyy-MM-DD")}
                        onChange={(event) => this.handleChange(event)}
                      />
                    </div>
                  </div>
                </div>

                {/* Full width Search button below the date fields */}
                <div className="col-span-2 mt-4 flex justify-end">
                  <button
                    className="btn btn-red text-white font-bold px-8 py-3 rounded w-full sm:w-auto text-base sm:text-lg"
                    onClick={() => this.getAllPostings()}
                  >
                    Search
                  </button>
                </div>

                {/* Add Post New Button */}
                <div className="col-span-12 add-btn-wrapper">
                  <Link to="/AddPosting">
                    <div className="col-span-12 mt-4 flex justify-end">
                      <button className="btn btn-red text-white font-bold px-8 py-3 rounded w-full sm:w-auto text-base sm:text-lg">
                        Add Post
                      </button>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full mx-auto">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6 mb-4">
              <div className="custom-card posting-card card border border-gray-300 rounded-md p-4 flex items-center shadow-sm">
                <div className="mr-4">
                  <p className="card-number">
                    {" "}
                    {this.state.postingList?.[0]?.numberOfPostings ?? 0}
                  </p>
                  <h3 className="card-title">Number of Postings</h3>
                </div>
              </div>

              <div className="custom-card posting-card border border-gray-300 rounded-md p-4 flex items-center shadow-sm">
                <div className="mr-4">
                  <p className="card-number">
                    {" "}
                    {this.state.postingList?.[0]?.numberOfResponses ?? 0}
                  </p>
                  <h3 className="card-title">Responses</h3>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full mx-auto">
            <div className="relative">
              <div>
                <div className="" onMouseLeave={() => this.onClose()}>
                  <Table
                    columns={[
                      { name: "companyName", title: "Company Name" },
                      {
                        name: "collaborationType",
                        title: "Collaboration Type",
                      },
                      { name: "title", title: "Title" },
                      { name: "postedOn", title: "Posted On" },
                      { name: "isActivePost", title: "Status" },
                      { name: "deadlineDate", title: "Deadline" },
                      { name: "collaborationPortalPostingId", title: "Action" },
                    ]}
                    rows={this.state.postingList}
                    isLoading={this.state.isLoading}
                    sortingColumns={["deadlineDate", "postedOn"]}
                    pagination={this.state.pagination}
                    totalResultes={this.state.totalResultes}
                    totalCount={this.state.totalResultes}
                    setPagination={this.setPagination.bind(this)}
                    customScope={[
                      {
                        column: "collaborationPortalPostingId",
                        renderTableData: this.actions2.bind(this),
                      },
                    ]}
                  />
                </div>
              </div>
            </div>
            <div className="members-modal-sec membersdirectoery">
              {this.state.dataGetting === true &&
              this.state.renewalMemberList.length > 0 ? (
                <RepresentativeDetailsModal
                  councilIndex={this.state.councilIndex}
                  getMemberDirectoryData={this.state.renewalMemberList}
                  setRepresentativeDetailsModal={
                    this.state.setRepresentativeDetailsModal
                  }
                  charLimit={this.state.charLimit}
                  setOpenModal={() =>
                    this.setState({ setRepresentativeDetailsModal: false })
                  }
                  onClose={(e) => {
                    e.stopPropagation();
                    this.setState({ setRepresentativeDetailsModal: false });
                  }}
                  cancelInvoiceAndRegenerateRenewalInvoice={this.cancelInvoiceAndRegenerateRenewalInvoice.bind(
                    this
                  )}
                  isLoadingcancelInvoice={this.state.isLoadingcancelInvoice}
                />
              ) : null}
            </div>
          </div>
        </main>
      </div>
    );
  }
}
